import { Div } from '@vkontakte/vkui';
import { useStoreMap, useUnit } from 'effector-react';
import { memo } from 'react';
import { Title, TitleSize } from 'src/shared/ui/title/Title';
import 'swiper/css';
import 'swiper/css/effect-cards';
import 'swiper/css/navigation';
import { EffectCards, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { $currentHeroesVkStatus, $heroesVkStatus, HeroesVkStatusGate } from '../model/HeroesVkStatus';
import { HeroCell } from './HeroCell/HeroCell';
import cls from './HeroesRow.module.scss';
import './swiper.css';

interface IHeroesRow {
  onImageStatusClick: (imageStatuseId: number) => void
}

export const HeroesRow = memo(({
  onImageStatusClick
}: IHeroesRow) => {
  const currentHeroesVkStatus = useUnit($currentHeroesVkStatus);
  const onClickHandler = (imageStatuseId: number) => () => {
    onImageStatusClick(imageStatuseId);
  };

  const heroesVkStatuses = useStoreMap({
    store: $heroesVkStatus,
    fn: heroesVkStatuses => heroesVkStatuses?.map(
      ({ id, name, images }) => (
        <SwiperSlide
          key={id}
          className={cls.swiperSlide}
          onClick={onClickHandler(id)}
        >
          <HeroCell
            name={name}
            img={images[0].url}
            isActive={currentHeroesVkStatus?.id === id}
          />
        </SwiperSlide>
      )
    ),
    keys: [
      currentHeroesVkStatus
    ]
  });

  return (
    <>
      <HeroesVkStatusGate />
      <Div>
        <Title
          align='center'
          size={TitleSize.XS}
        >
          Выбери свой эмодзи-статус
        </Title>
        <Swiper
        // @ts-ignore
          navigation
          effect='cards'
          grabCursor
          modules={[Navigation, EffectCards]}
          className={cls.swiper}
        >
          {heroesVkStatuses}
        </Swiper>
      </Div>
    </>
  );
});
